module.exports = __webpack_public_path__ + "img/3.f87a03cc.png";